/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjcxIDEuMjkwMDFMNyAyLjAwMDAxTDEzIDguMDAwMDFMNyAxNEw3LjcxIDE0LjcxTDE0LjQyIDguMDAwMDFMNy43MSAxLjI5MDAxWk0yIDEuMjkwMDFMMS4yOSAyLjAwMDAxTDcuMjkgOC4wMDAwMUwxLjI5IDE0TDIgMTQuNzFMOC43MSA4LjAwMDAxTDIgMS4yOTAwMVoiIGZpbGw9ImluaGVyaXQiLz4=";